export enum types {
	ADD_ERROR = 'ADD_ERROR',
	REMOVE_ERROR = 'REMOVE_ERROR',
	REMOVE_ALL_ERRORS = 'REMOVE_ALL_ERRORS',
}

export interface ErrorsState {
	errors: string[]
}
